import { createSelector } from 'reselect';
import type { ReportKey } from '../../../model/types';
import type { State } from '../../types';

export const getReportKeysOrdered = (state: State) => state.entities.reportsOrder;
const getReportEntities = (state: State) => state.entities.reports;

export const getReportByKey = (state: State, reportKey: ReportKey) =>
	state.entities.reports[reportKey];

export const getReports = createSelector(
	[getReportEntities, getReportKeysOrdered],
	(entities, keys) => keys.map((key) => entities[key]),
);
